import { Navigation } from '@/components/NavigationContext'
import Head from 'next/head'
import Link from 'next/link'
import { useContext, useEffect } from 'react'

const Contact = ({ content, navigation }) => {
    const { setNavigationItems } = useContext(Navigation)
    
    useEffect(() => {
        if (navigation) {
            setNavigationItems(navigation)
        }
    }, [navigation])

    return (
        <>
            <Head>
                <title>Contact | Studio Rinsma</title>
                <meta name="description" content={content.contactHeader.title} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <div className="page-contact">
                <section className="contact-main">
                    <div className="global-wrapper">
                        <div className="contact-main-inner">
                            <div className="image-wrapper">
                                <img src={content.contactHeader.image.url} alt={content.contactHeader.image.title} />
                            </div>

                            <div className="contact-content">
                                <h1>
                                    <span className="heading-js-wrapper">
                                        <span style={{animationDelay: '.2s'}}>{content.contactHeader.title}</span>
                                    </span>
                                </h1>

                                <div className="loadup-wrapper">
                                    <div className="contact-options">
                                        <div className="contact-option">
                                            <span className="option-title">{content.contactSocialMediaSection.title}</span>
                                            <ul>
                                                {content.contactSocialMediaSection.links.map((item, index) => (
                                                    <li key={index}>
                                                        <a href={item.link} target={'_blank'} rel={'nofollow noreferrer noopener'}>
                                                            {item.title}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                        <div className="contact-option">
                                            <span className="option-title">{content.contactSection.title}</span>
                                            <ul>
                                                {content.contactSection.links.map((item, index) => (
                                                    <li key={index}>
                                                        <a href={item.link} target={'_blank'} rel={'nofollow noreferrer noopener'}>
                                                            {item.title}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-text-wrapper">
                                    <div className="hover-circle" />
                                    <span className="contact-text">{content.contactQuoteText}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cta-wrapper">
                    <div className="global-wrapper">
                        <Link href={`/${content.cta.link}`} className="cta-inner">
                            <div className="cta-content">
                                <span className="cta-title">{content.cta.title}</span>
                                <span className="cta-subtext">{content.cta.subtext}</span>
                            </div>

                            <div className="cta-link-wrapper">
                                <i className="fas fa-arrow-right-long" />
                            </div>
                        </Link>
                    </div>
                </section>
            </div>
        </>
    )
}

export default Contact

export async function getServerSideProps() {
	const res = await fetch(`${process.env.API_URL}/page/contact.json`)
	const content = await res.json()

	const navigationRes = await fetch(`${process.env.API_URL}/api/globals.json`)
	const navigation = await navigationRes.json()

	return {
		props: {
			content,
			navigation,
		}
	}
}